import React, { useState, useEffect } from 'react';
import { api } from '../api';
import './Modal.css';

function fmtGB(bytes) {
  return (bytes / (1024 ** 3)).toFixed(2);
}

export default function QuotaModal({ domain, onClose }) {
  const [quota, setQuota] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [newSizeGB, setNewSizeGB] = useState('');
  const [saving, setSaving] = useState(false);

  function load() {
    setLoading(true);
    api.getQuota(domain)
      .then(d => { setQuota(d); setNewSizeGB(Math.round(d.totalBytes / (1024 ** 3)).toString()); })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }

  useEffect(load, [domain]);

  async function handleSave() {
    const sizeGB = parseInt(newSizeGB, 10);
    if (!Number.isInteger(sizeGB) || sizeGB <= 0) {
      setError('Enter a positive whole number of GB');
      return;
    }
    setError('');
    setSaving(true);
    try {
      await api.setQuota(domain, sizeGB);
      load();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }

  const usedPct = quota ? Math.min(100, (quota.usedBytes / quota.totalBytes) * 100) : 0;
  const currentGB = quota ? Math.round(quota.totalBytes / (1024 ** 3)) : 0;

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h2>💾 Quota — {domain}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="center"><div className="spinner" /></div>
          ) : (
            <>
              {quota && (
                <div className="field">
                  <label>Usage</label>
                  <div className="quota-bar">
                    <div
                      className={`quota-bar-fill ${usedPct > 90 ? 'quota-bar-danger' : usedPct > 70 ? 'quota-bar-warn' : ''}`}
                      style={{ width: `${usedPct}%` }}
                    />
                  </div>
                  <span className="field-hint">
                    {fmtGB(quota.usedBytes)} GB used of {fmtGB(quota.totalBytes)} GB ({usedPct.toFixed(1)}%)
                  </span>
                </div>
              )}

              <div className="field">
                <label>New quota (GB) — grow only</label>
                <input
                  type="number"
                  min={currentGB + 1}
                  value={newSizeGB}
                  onChange={e => setNewSizeGB(e.target.value)}
                  className="compose-preview"
                  style={{ fontSize: 14, padding: '8px 10px', resize: 'none' }}
                />
                <span className="field-hint">Shrinking isn't supported — ext4 can't shrink online.</span>
              </div>

              {error && <div className="modal-error">{error}</div>}

              <div className="modal-footer">
                <button className="btn-ghost" onClick={onClose}>Close</button>
                <button className="btn-primary" onClick={handleSave} disabled={saving}>
                  {saving ? 'Growing...' : 'Grow quota'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
